module.exports = __webpack_public_path__ + "img/xg.0d9f3052.svg";